import React from "react";
import PropTypes from "prop-types";
import styles from "./RadioButtonGroup.module.css";

import RadioButton from "../RadioButton";
import classNames from "classnames";
import propTypes from "prop-types";

/**
 * Interactive component. A radio button group.
 */
export function RadioButtonGroup({
  orientation,
  currentlySelected,
  setCurrentlySelected,
  options,
  className,
}) {
  return (
    <div className={classNames(styles.container, className)}>
      <fieldset
        className={styles.group}
        style={{ flexDirection: orientation === "vertical" ? "column" : "row" }}
      >
        {options.map((option, index) => (
          <RadioButton
            key={option + index}
            isSelected={option === currentlySelected}
            setCurrentlySelected={setCurrentlySelected}
            value={option}
          />
        ))}
      </fieldset>
    </div>
  );
}

RadioButtonGroup.propTypes = {
  /**
   * Determines the orientation of the radio group. Defaults to "horizontal".
   */
  orientation: PropTypes.oneOf(["vertical", "horizontal"]),
  /**
   * The value of the currently selected radio button.
   */
  currentlySelected: PropTypes.string,
  /**
   * Function that fires when the selected radio button changes.
   */
  setCurrentlySelected: PropTypes.func,
  /**
   * An array of the radio button values.
   */
  options: PropTypes.arrayOf(PropTypes.string),
  className: propTypes.string,
};

RadioButtonGroup.defaultProps = {
  orientation: "horizontal",
  options: [],
};
